/**
 * Exchange configuration constants
 * Note: This is a fallback list. The actual list should be fetched dynamically
 * from /admin/exchanges to show only configured exchanges.
 */
export const EXCHANGES = [
  { id: 'binance', name: 'Binance', hasSubAccounts: true },
  { id: 'bybit', name: 'Bybit', hasSubAccounts: true },
  { id: 'okx', name: 'OKX', hasSubAccounts: true },
  { id: 'kucoin', name: 'KuCoin', hasSubAccounts: true },
  { id: 'gateio', name: 'Gate.io', hasSubAccounts: false },
  { id: 'woox', name: 'WOO X', hasSubAccounts: false },
  { id: 'hyperliquid', name: 'Hyperliquid', hasSubAccounts: false },
  { id: 'bullish', name: 'Bullish', hasSubAccounts: false },
  { id: 'extended', name: 'Extended', hasSubAccounts: false },
  { id: 'lighter', name: 'Lighter', hasSubAccounts: false },
];

// Exchange metadata (sub-account support, display names, etc.)
export const EXCHANGE_METADATA = {
  binance: { hasSubAccounts: true, name: 'Binance' },
  bybit: { hasSubAccounts: true, name: 'Bybit' },
  okx: { hasSubAccounts: true, name: 'OKX' },
  kucoin: { hasSubAccounts: true, name: 'KuCoin' },
  gateio: { hasSubAccounts: false, name: 'Gate.io' },
  woox: { hasSubAccounts: false, name: 'WOO X' },
  hyperliquid: { hasSubAccounts: false, name: 'Hyperliquid' },
  bullish: { hasSubAccounts: false, name: 'Bullish' },
  extended: { hasSubAccounts: false, name: 'Extended' },
  lighter: { hasSubAccounts: false, name: 'Lighter' },
};

export const EXCHANGE_IDS = EXCHANGES.map(e => e.id);
export const EXCHANGE_NAMES = EXCHANGES.map(e => e.name);

// Account types supported by each exchange
// Maps exchange ID to array of supported account types
export const EXCHANGE_ACCOUNT_TYPES = {
  woox: ['spot', 'perp'], // WOOX only supports spot and perp
  kucoin: ['main', 'trade', 'futures', 'margin'], // KuCoin: MAIN (funding), TRADE (spot), FUTURES, MARGIN
  bybit: ['unified', 'funding'], // Bybit: UNIFIED (spot/futures), FUND (funding/main)
  okx: ['funding', 'spot'], // OKX: FUNDING (separate), SPOT (unified trading account - includes both spot and futures)
  hyperliquid: ['futures'], // Hyperliquid only supports futures
  binance: ['spot', 'futures'], // Binance: Spot and Futures (exclude Earn/funding and Margin)
  gateio: ['spot', 'futures', 'margin', 'funding'], // Gate.io supports multiple
  bullish: [], // Bullish doesn't have separate account types
  extended: [], // Extended doesn't have separate account types
  lighter: ['futures'], // Lighter only supports futures
};
